window.SubscriptionFunnel.FunnelNavigation = {
  nextStep(skip = false) {
    if (!skip) {
      SubscriptionFunnel.FunnelUtilities.storeStepData(currentStepIdx);
    }
    SubscriptionFunnel.FunnelUtilities.updateProgressBar(currentStepIdx + 1);
    handleSubmitRudderstack(currentStepIdx, skip);
    const allowPrepaid = SubscriptionFunnel.FunnelUtilities.showPrepaidOffer;

    if (currentStepIdx + 1 === steps.length) {
      this.disablePrimaryButtons();
      completeQuiz();
      return;
    }

    if (steps[currentStepIdx] === "select-dog-name-gender") {
      SubscriptionFunnel.StepNameAndGender.initialize();
    } else if (steps[currentStepIdx + 1] === "select-commitment-length") {
      SubscriptionFunnel.StepPlanSelection.initialize(allowPrepaid);
    } else if (steps[currentStepIdx + 1] === "select-extra-toy") {
      SubscriptionFunnel.StepExtraToy.initialize();
    } else if (steps[currentStepIdx + 1] === "select-upsell") {
      SubscriptionFunnel.StepUpsell.initializeUpsellOptions();
    } else if (steps[currentStepIdx + 1] === "select-payment-option") {
      if (
        Number(quizData.commitmentLength) !== 3 &&
        Number(quizData.commitmentLength) !== 6 &&
        Number(quizData.commitmentLength) !== 12
      ) {
        this.disablePrimaryButtons();
        completeQuiz();
        return;
      }
      SubscriptionFunnel.StepPaymentOption.initialize();
    } else if (steps[currentStepIdx + 1] === "email-capture") {
      SubscriptionFunnel.StepEmail.populateRecap?.();
    }

    // Move to next step
    this.updateStepUI();
    handleNavRudderstack(titleMapping[currentStepIdx + 1]);
    currentStepIdx += 1;
  },

  // Helper function to disable buttons and show loader
  disablePrimaryButtons() {
    document.querySelectorAll(".button--primary").forEach((el) => {
      el.disabled = true;
      el.querySelector(".button-text").classList.add("display-none");
      el.querySelector(".loader").classList.remove("display-none");
    });
  },

  enablePrimaryButtons() {
    document.querySelectorAll(".button--primary").forEach((el) => {
      el.disabled = false;
      el.querySelector(".button-text").classList.remove("display-none");
      el.querySelector(".loader").classList.add("display-none");
    });
  },

  updateStepUI() {
    document.getElementById(steps[currentStepIdx]).classList.remove("active");
    document.getElementById(steps[currentStepIdx + 1]).classList.add("active");
    document
      .getElementById(steps[currentStepIdx] + "-header")
      .classList.remove("active");
    const header = document.getElementById(
      steps[currentStepIdx + 1] + "-header"
    );
    header.classList.add("active");
    header.focus();
  },

  prevStep() {
    handleNavRudderstack(titleMapping[currentStepIdx - 1]);
    document.getElementById(steps[currentStepIdx]).classList.remove("active");
    document.getElementById(steps[currentStepIdx - 1]).classList.add("active");
    document
      .getElementById(steps[currentStepIdx] + "-header")
      .classList.remove("active");
    const header = document.getElementById(
      steps[currentStepIdx - 1] + "-header"
    );
    header.classList.add("active");
    header.focus();
    SubscriptionFunnel.FunnelUtilities.updateProgressBar(currentStepIdx - 1);

    if (steps[currentStepIdx - 1] === "email-capture") {
      SubscriptionFunnel.StepEmail.populateRecap?.();
    }

    currentStepIdx = currentStepIdx - 1;
  },
};
